<template>
  <div class="page-section padding-top-20">
    <p class="section-subtitle">
      The simplest and <b>easiest</b> way to save, by Salary Finance:
    </p>
    <div class="breakdown-table">
      <div class="savings-icons">
        <img src="../../../../assets/salary-finance/coventry-logo.svg" />
        <img src="../../../../assets/salary-finance/fscs-logo.svg" />
      </div>
      <div class="breakdown-header">
        <h3>Your easy access savings account</h3>
      </div>
      <div class="breakdown-content">
        <div class="breakdown-row-no-border">
          <div class="col source">
            <span class="bullet-point">•</span> 2.5% AER*/2.47% gross p.a. (variable)
          </div>
        </div>

        <div class="breakdown-row-no-border">
          <div class="col source">
            <span class="bullet-point">•</span> Unlimited withdrawals with no charges
          </div>
        </div>

        <div class="breakdown-row-no-border">
          <div class="col source">
            <span class="bullet-point">•</span> Take money out online at any time
          </div>
        </div>

        <div class="breakdown-row-no-border">
          <div class="col source">
            <span class="bullet-point">•</span> FSCS** protected up to £85,000
          </div>
        </div>
      </div>
      <button class="blue-button" @click="handleButtonClick">
        Start saving <span class="arrow-right vertical-align-middle">→</span>
      </button>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['buttonClick']);

const handleButtonClick = () => {
  emit('buttonClick');
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/riseup-vars';

.info-title {
  font-size: 36px;
  font-family: 'SalaryFinance';
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.white {
  color: #FFFFFF;
}

.info-title b {
  font-weight: 700;
}

.section-subtitle {
  font-size: 17px;
  font-family: 'SalaryFinance';
  margin-top: 25px;
  margin-bottom: 40px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.breakdown-table {
  width: 90%;
  background-color: white;
  box-shadow: 0px 16px 46.4px 0px #00000026;
  border-radius: 25px;
  padding: 25px;
  margin-top: 20px;
  z-index: 2;
  margin: 0 auto;
  position: relative;
  padding-top: 30px;
}

.savings-icons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.breakdown-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  h3 {
    margin: 0;
    color: #F14241;
    font-size: 20px;
  }
}

.breakdown-content {
  width: 100%;
}

.breakdown-row-no-border {
  display: flex;
  padding: 5px 5px;
  font-family: 'SalaryFinance';
}

.col {
  color: #0C3467;

  &.source {
    flex: 4;
    text-align: left;
  }
}

.blue-button {
  background-color: #002579;
  color: white;
  width: 100%;
  border-radius: 12px;
  padding: 10px 0px;
  border: none;
  cursor: pointer;
  font-size: 18px;
  font-family: 'SalaryFinance';
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  padding-top: 16px;
  padding-bottom: 18px;
}

.arrow-right {
  margin-left: 10px;
  font-family: 'SalaryFinance';
  color: #FD5F5A;
  font-size: 30px;
}

.bullet-point {
  font-size: 10px;
  color: #202125;
}

.padding-top-20 {
  padding-top: 20px;
}

.vertical-align-middle {
  vertical-align: middle;
}
</style>
